import { Component, input, output } from "@angular/core";
import { Icon } from "../utils/icon/icon";
import { TranslocoModule } from "@jsverse/transloco";
import { FavoriteFilterSearchInterface } from "src/app/core/interfaces/favorite-interface";

@Component({
  selector: "app-card-favorite-search",
  imports: [Icon, TranslocoModule],
  templateUrl: "./card-favorite-search.html",
})
export class CardFavoriteSearch {
  favoriteFilter = input.required<FavoriteFilterSearchInterface>();
  isInEditMode = input<boolean>(false);
  isSelected = output<number>();
  applySearch = output<FavoriteFilterSearchInterface>();

  handleCardClick(): void {
    if (!this.isInEditMode()) {
      this.applySearch.emit(this.favoriteFilter());
    }
  }

  handleCheckboxChange(): void {
    this.isSelected.emit(this.favoriteFilter().id);
  }
}
